import type { Option, SortItem } from "@app/core";

import type { HeatMode } from "./utils";

import { PARTNERSHIP_LABELS, PARTNERSHIPS } from "@/features/partnership";
import type { Partnership } from "@/features/partnership";

export const ROLE_OPTIONS: Option[] = [
  { value: null, label: "All roles" },
  { value: "admin", label: "Administrator" },
  { value: "client", label: "Client" },
  { value: "internal", label: "Internal" },
];

export const STATUS_OPTIONS: Option[] = [
  { value: "all", label: "All statuses" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

export const DEFAULT_SORT: Readonly<SortItem> = { field: "total", order: "desc" };

export const PARTNERSHIP_OPTIONS: Array<{ value: Partnership | "all", label: string }> = [
  { value: "all", label: "All" },
  { value: PARTNERSHIPS.SellerCentral, label: PARTNERSHIP_LABELS[PARTNERSHIPS.SellerCentral] },
  { value: PARTNERSHIPS.VendorCentral, label: PARTNERSHIP_LABELS[PARTNERSHIPS.VendorCentral] },
];

export const HEAT_OPTIONS: Array<{ value: HeatMode, label: string }> = [
  { value: "overall", label: "Overall" },
  { value: "row", label: "By row" },
  { value: "column", label: "By column" },
];

// Alpha over the theme background: the numbered primary scale does not flip in dark mode.
export const HEAT_CLASSES = [
  "",
  "!bg-primary-700/10",
  "!bg-primary-700/25",
  "!bg-primary-700/45",
  "!bg-primary-700/65",
  "!bg-primary-700/90 text-white",
];
